import {
  Button, IconButton, Stack, TextField,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import { useState } from 'react';
import { ConfirmDialogBox } from '../../../components/CustomDialogBox';
import { TREE_CONSTANTS } from '../utils/constants';

function ModifyLevels({
  levels, setLevels, treeData, setModify, setDirty,
}) {
  const [tempLevels, setTempLevels] = useState([...levels]);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogMessage, setDialogMessage] = useState('');

  const handleChange = (index, value) => {
    const updated = tempLevels.map((lvl, i) => (i === index ? { ...lvl, name: value } : lvl));
    setTempLevels(updated);
  };

  const isLevelInUse = (node, levelToCheck) => {
    if (node.level === levelToCheck) return true;
    return node.children?.some((child) => isLevelInUse(child, levelToCheck));
  };

  const handleDelete = (index) => {
    if (tempLevels.length === 1) {
      setDialogMessage('At least one level must be present (excluding Features).');
      setDialogOpen(true);
      return;
    }

    const levelToRemove = tempLevels[index].level;

    const inUse = Array.isArray(treeData)
      ? treeData.some((node) => isLevelInUse(node, levelToRemove))
      : isLevelInUse(treeData, levelToRemove);

    if (inUse) {
      setDialogMessage(
        'You cannot delete a level that is currently used in the tree. Remove nodes from that level first.',
      );
      setDialogOpen(true);
      return;
    }

    const updated = [...tempLevels];
    updated.splice(index, 1);
    setTempLevels(updated);
  };

  const handleAdd = () => {
    if (tempLevels.length >= TREE_CONSTANTS.MAX_LEVELS) {
      setDialogMessage('You cannot add more than 4 levels. Please delete an existing level first.');
      setDialogOpen(true);
      return;
    }

    const newLevel = { level: tempLevels.length + 1, name: '' };
    setTempLevels([...tempLevels, newLevel]);
  };

  const handleCancel = () => {
    setModify(false);
  };

  const handleSave = () => {
    const hasEmpty = tempLevels.some((level) => !level.name.trim());

    if (hasEmpty) {
      setDialogMessage('Level names cannot be empty. Please provide valid names before saving.');
      setDialogOpen(true);
      return;
    }

    setLevels(tempLevels);
    setDirty(true);
    setModify(false);
  };

  return (
    <Stack width="min(400px, 100%)" gap={2}>
      {tempLevels.map((level, index) => (
        <TextField
          key={level.level}
          label={`Level ${index + 1}`}
          value={level.name}
          onChange={(e) => handleChange(index, e.target.value)}
          fullWidth
          InputProps={{
            endAdornment: (
              <IconButton onClick={() => handleDelete(index)} size="small" color="primary">
                <DeleteIcon fontSize="small" />
              </IconButton>
            ),
          }}
        />
      ))}

      <Stack direction="row" gap={1} justifyContent="space-between">
        <Button size="small" onClick={handleAdd} startIcon={<AddIcon />} disabled={tempLevels.length >= TREE_CONSTANTS.MAX_LEVELS}>
          Add Level
        </Button>
        <Stack direction="row" gap={1}>
          <Button size="small" onClick={handleCancel} variant="outlined">
            Cancel
          </Button>
          <Button size="small" onClick={handleSave} variant="contained" color="primary">
            Save
          </Button>
        </Stack>
      </Stack>

      <ConfirmDialogBox
        openDialog={dialogOpen}
        title="Invalid Action"
        message={dialogMessage}
        onClose={() => setDialogOpen(false)}
        cancelText="OK"
      />
    </Stack>
  );
}

export default ModifyLevels;
